import { render } from "./DriverBadges.vue?vue&type=template&id=3a0aae19&scoped=true"
import script from "./DriverBadges.vue?vue&type=script&lang=js"
export * from "./DriverBadges.vue?vue&type=script&lang=js"

import "./DriverBadges.vue?vue&type=style&index=0&id=3a0aae19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0aae19"]])

export default __exports__